"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const yup_1 = require("yup");
const i18next_1 = __importDefault(require("i18next"));
const utils_1 = require("@sqvr/utils");
function setYupLocale() {
  (0, yup_1.setLocale)({
    mixed: {
      default: i18next_1.default.t('yup.mixed.default'),
      required: i18next_1.default.t('yup.mixed.required'),
      oneOf: i18next_1.default.t('yup.mixed.oneOf'),
      notOneOf: i18next_1.default.t('yup.mixed.notOneOf')
    },
    string: {
      length: ({
        length
      }) => i18next_1.default.t('yup.string.length', {
        count: length
      }),
      min: i18next_1.default.t('yup.string.min'),
      max: i18next_1.default.t('yup.string.max'),
      matches: i18next_1.default.t('yup.string.matches'),
      email: i18next_1.default.t('yup.string.email'),
      url: i18next_1.default.t('yup.string.url'),
      trim: i18next_1.default.t('yup.string.trim'),
      lowercase: i18next_1.default.t('yup.string.lowercase'),
      uppercase: i18next_1.default.t('yup.string.uppercase')
    },
    number: {
      min: i18next_1.default.t('yup.number.min'),
      max: i18next_1.default.t('yup.number.max'),
      lessThan: i18next_1.default.t('yup.number.lessThan'),
      moreThan: i18next_1.default.t('yup.number.moreThan'),
      notEqual: i18next_1.default.t('yup.number.notEqual'),
      positive: i18next_1.default.t('yup.number.positive'),
      negative: i18next_1.default.t('yup.number.negative'),
      integer: i18next_1.default.t('yup.number.integer')
    },
    date: {
      min: ({
        min
      }) => i18next_1.default.t('yup.date.min', {
        date: (0, utils_1.formatDate)(min)
      }),
      max: ({
        max
      }) => i18next_1.default.t('yup.date.max', {
        date: (0, utils_1.formatDate)(max)
      })
    },
    object: {
      noUnknown: i18next_1.default.t('yup.object.noUnknown')
    },
    array: {
      min: ({
        min
      }) => i18next_1.default.t('yup.array.min', {
        count: min
      }),
      max: ({
        max
      }) => i18next_1.default.t('yup.array.max', {
        count: max
      })
    }
  });
}
exports.default = setYupLocale;